import Vue from 'vue'

import Contextmenu from 'vue-contextmenujs'
Vue.use(Contextmenu)

import '@/assets/theme.less'
import '@/assets/global.css'
import '@/assets/iconfont/iconfont.css'
import '@/main.css'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import ActionSheetService from '@/utils/actionsheet'

Vue.prototype.$actionSheet = ActionSheetService

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { RecycleScroller } from 'vue-virtual-scroller'
Vue.component('RecycleScroller', RecycleScroller)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
import WxlListPlugin from '@/plugins/wxl-list'
Vue.use(WxlListPlugin)

Vue.use(Element, {
  size: Cookies.get('size') || 'medium'// set element-ui default size
})

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import Ellipsis from '@/components/Common/Ellipsis'
import WDialog from '@/components/Common/WDialog'
Vue.use(WDialog)
Vue.use(Ellipsis)
Vue.prototype.isNumber = function(str) {
    if (typeof str === 'number') {
        return true
    }
    var re = /^[0-9]*[1-9][0-9]*$/
    return re.test(str)
}
Vue.prototype.$isNotEmpty = function(obj) {
    return (obj !== undefined && obj !== null && obj !== '' && obj !== 'null')
}
Vue.prototype.showprocess = () => {
    const loading = Vue.prototype.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    })
    return loading
}
Vue.prototype.newGuid = (key = '-') => {
    return `xxxxxxxx${key}xxxx${key}4xxx${key}yxxx${key}xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0
        var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}
Vue.prototype.getUrlParam = (name) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
    var r = decodeURIComponent(window.location.search).substr(1).match(reg) // 匹配目标参数
    if (r != null) return unescape(r[2]); return null // 返回参数值
}
Vue.prototype.convertString2Base64 = (str) => {
    return window.btoa(unescape(encodeURIComponent(str)))
}
Vue.prototype.convertBase642String = (base64) => {
    return decodeURIComponent(escape(window.atob(base64)))
}
Vue.prototype.$deepCopy = (obj) => { return JSON.parse(JSON.stringify(obj)) }

Array.prototype.remove = function (value) {
    let index = this.indexOf(value)
    if (index > -1) {
      this.splice(index, 1)
    }
    return index
}
//移除对象数组，匹配唯一key
Array.prototype.removeByKey = function (key, val) {
    let index = this.findIndex(value => value[key] === val)
    if (index > -1) {
      this.splice(index, 1)
    }
    return index
}
  
//对象数组转map
Array.prototype.toMap = function (key) {
    let map = new Map()
    this.forEach(v => map.set(v[key], v))
    return map
}
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import VueFab from 'vue-float-action-button'

Vue.use(VueFab,{
    iconType: 'iconfont'
})

Number.prototype.ParseNumber = function(precision) {
    //首先放大10的precision次方倍
    var value =this*Math.pow(10,precision);
    //四舍五入
    value=Math.round(value);
    //再缩小10的precision次方倍
    value=value/Math.pow(10,precision);

    //保留小数点后precision位
    value=parseFloat(value.toFixed(precision));
    //去0
    value=parseFloat(value.toString());
    return value;
}
Number.prototype.parseNumber=function(precision){
    return this.ParseNumber(precision);
}
String.prototype.ParseString = function() {
    return this
}
Number.prototype.ParseString=function(precision){
    // 数值放大并精确四舍五入
    let scaled = this * Math.pow(10, precision);
    scaled = Math.round(scaled);
    
    // 恢复原始量级
    let result = scaled / Math.pow(10, precision);
    
    // 格式化为字符串并去除末尾零
    return parseFloat(result.toFixed(precision)).toString();
}
Vue.prototype.$debounce = function(fn, delay) {
    let timer = null
    return function() {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn.apply(this, arguments)
        }, delay)
    }
}
Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this	// 安装全局事件总线
    }
})